import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from 'react-bootstrap';
import { InstitutionViewRow } from 'cb-model';
import styles from './InstitutionCard.module.css';

interface InstitutionCardProps {
  row: InstitutionViewRow;
}

export const InstitutionCard = (props: InstitutionCardProps): React.JSX.Element => {
  return (
    <Card>
      <Card.Body>
        <Link to={`/website/institution/${props.row.id}`} className={styles.InstitutionCard}>
          <img src={props.row.logo || '/assets/icons/building-library.svg'} alt={`${props.row.name} logo`} />
          {props.row.name}
        </Link>
      </Card.Body>
    </Card>
  );
};
